export default {
  adms: {
    detail_title: "Детальная информация",
    detail_ok: "Ок",
    detail_cancel: "Отмена",
    add_title: "Добавление нового элемента в каталог",
    add_cancel: "Отменить",
    add_ok: "Добавить",
    catalog_title: "Информация о каталоге",
    catalog_cancel: "Закрыть",
    catalog_ok: "Редактировать",
    select_title: "Выбор актива для включения в каталог",
    select_cancel: "Закрыть",
    select_ok: "Выбрать",
    establishing_link_title: "Установить связь",
    establishing_link_content: "Включить выбранные элементы в каталог {{iri}}?",
    establishing_link_ok: "Да", 
    establishing_link_cancel: "Нет",
    establishing_link_success: "Связь установлена!",
    establishing_link_error: "Не удалось установить связь. {{e}}",
    break_link_title: "Разорвать связь", 
    break_link_content: "Исключить выбранные элементы из каталога {{iri}}? Данные не будут удалены!",
    break_link_ok: "Да", 
    break_link_cancel: "Нет",
    break_link_success: "Связь разорвана!",
    break_link_error: "Не удалось разорвать связь. {{e}}",
    list_add_title: "Добавление нового элемента в каталог",
    list_reload_title: "Пересчитать список",
    catalog_information_title: "Информация о каталоге",
    jsonld_title: "Посмотреть микроразметку",
    export_title: "Экспорт в формат DOC и PDF",
    export_card: "Экспорт карточки",
    card_tab_card: "Карточка",
    card_tab_collaboration: "Коллективная работа",
    card_tab_content: "Содержимое",
    collaboration: {
      lifecycle_header: "Жизненный цикл",
      lifecycle_none: "Нет жизненного цикла, связанного с элементом каталога",
      event_header: "События",
      event_none: "Нет событий, связанных с элементом каталога",
      wiki_header: "Wiki",
    },
    object_property_directories : "Настройка справочников объектных свойств",
    settings_taxonomy: "Натройка таксономии",
    return_catalog: "Вернуться в каталог",
    link_asset: "Включить актив",
    catalog_lang: "Язык каталога моделей",
    import_card_asset: "Импорт карточки каталога"
  },
  model: {
    no_views: "Нет настроенных представлений содержимого элемента каталога",
    no_used: "В текущем режиме использование представления {{view_title}} невозможно!\n",
    copied_link: "В буфер обмена скопирована ссылка на представление.\n {{url}}",
    copy_link: "Скопировать ссылку",
    back: "Вернуться к содержимому",
  },
  admin: {
    landing: {
      title: "Настройка каталога",
      schemes: "Cправочники",
      vocabs: "Реестр объектов",
      sksaowl: "Онтология каталога",
      catalogs: "Каталоги",
      catalog: "Каталог",
      namespaces: "Префиксы пространств имен"
    },
    return_admin_panel: "Вернутся в настройки",
    add_concept_scheme: "Добавление нового справочника",
    add_vocabs_individual: "Добавление нового объекта в реестр",
    import_conceptscheme: "Импорт справочника",
    import_vocabs_individual: "Импортировать объект",
    return_catalogs: "Вернутся в список каталогов"
  },
  skos: {
    common: {
      ok: "Ок",
      cancel: "Отмена",
      close: "Закрыть",
      add: "Добавить",
      yes: "Да",
      no: "Нет",
      deleteSelected: "Удалить выбранный элемент"
    },
    conceptCard: {
      addProperty: "Добавление свойства",
      selectItem: "Выбор элемента",
      deleteProperty: "Удалить выбранное свойство?",
      selectionCancelled: "Выбор объекта отменён.",
      reloadToViewChanges: "Для просмотра изменений перегрузите страницу."
    },
    schemeList: {
      descriptionRequired: "Пожалуйста, укажите описание справочника",
      uriExists: "URI {{iri}} уже существует. Задайте другой идентификатор.",
      addSuccess: "Добавление записи завершено успешно.",
      addError: "Ошибка при добавлении элемента в каталог. {{error}}",
      iriUniquenessError: "Не удалось определить уникальность IRI. {{error}}"
    },
    schemeCard: {
      addProperty: "Добавление свойства",
      details: "Детальная информация",
      usedBy: "Используют",
      selectConcept: "Выбрать концепт",
      rootFlagHelp: "Флаг, что концепт является корневым элементом в схеме",
      rootOrBroaderRequired: "Должен быть заполнен либо флаг «Корневой в схеме», либо выбран более общий концепт",
      rootInScheme: "Корневой в схеме",
      broaderConceptHelp: "Концепт более общего понятия.",
      broader: "Более общий",
      conceptDescriptionRequired: "Пожалуйста, укажите описание концепта",
      editConcept: "Редактирование концепта",
      schemeHasConcepts: "В схеме есть концепты — {{count}} шт. Схему можно удалить, когда будут удалены все концепты!",
      recordDeleted: "Запись удалена.",
      conceptDeleted: "Концепт удалён.",
      conceptDeleteError: "Ошибка удаления концепта.",
      unlinkConcept: "Исключить концепт из справочника",
      conceptUnlinked: "Концепт исключён.",
      conceptUnlinkError: "Ошибка исключения концепта.",
      uriExists: "URI {{iri}} уже существует. Задайте другой идентификатор.",
      linkConceptError: "Ошибка связи схемы с концептом. {{error}}",
      backToSchemes: "Вернуться в список справочников",
      addConcept: "Добавление нового концепта",
      linkConcept: "Связать концепт со схемой",
      deleteSchemeAndConcepts: "Удаление справочника и всех концептов",
      viewMode: "Режим просмотра данных",
      editMode: "Режим редактирования",
      removeSchemeFromCatalog: "Удалить справочник из каталога",
      schemeDeleted: "Справочник удалён."
    },
    inSchemeCard: {
      hasNarrowerConcepts: "У концепта есть уточняющие понятия — {{count}} шт. Концепт можно удалить, когда будут удалены все уточняющие концепты!",
      deleteUsedConcept: "Концепт «{{name}}» используется! Всё равно удалить?",
      deleteConcept: "Удалить концепт «{{name}}»?",
      noRelatedConcepts: "Нет связанных концептов."
    },
    scheme: {
      used_information: "Информация об использовании справочника",
      synchronize: "Выгрузить справочник в другой граф"
    },
    export: {
      model: "Экспорт справочника"
    }
  },
  catalog: {
    graph_field : "Граф",
    export: "Экспорт каталога"
  }
}
